import { render, staticRenderFns } from "./ConfirmChanges.vue?vue&type=template&id=0b13e78b&scoped=true&lang=pug"
import script from "./ConfirmChanges.vue?vue&type=script&lang=js"
export * from "./ConfirmChanges.vue?vue&type=script&lang=js"
import style0 from "./ConfirmChanges.vue?vue&type=style&index=0&id=0b13e78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13e78b",
  null
  
)

export default component.exports